export const BADGE_TYPES = ['question' as const, 'link' as const, 'answer' as const]
